import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveCalendarHolidaysRequestFailure(calendarHolidays) {
      const state = getState().find(
        ({ calendarHolidays: { uuid } }) => calendarHolidays.uuid === uuid,
      );
      return state ? state.request.isFailure : false;
    },
    isRemoveCalendarHolidaysRequestPending(calendarHolidays) {
      const state = getState().find(
        ({ calendarHolidays: { uuid } }) => uuid === calendarHolidays.uuid,
      );
      return state ? state.request.isPending : false;
    },
    isRemoveCalendarHolidaysRequestSuccess(calendarHolidays) {
      const state = getState().find(
        ({ calendarHolidays: { uuid } }) => uuid === calendarHolidays.uuid,
      );
      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
